import logo from "./assets/logo.webp";
import LogoCard from "./elements/LogoCard";
import Form from "./elements/Form";

import "@fontsource/montserrat";
import Nav from "./elements/Nav";

function App() {
  return (
      <>
          <Nav />
          <LogoCard/>
          <img src={logo}  alt="logo" className="logo"/>
          <dialog id="dialog">
              <Form />
          </dialog>
      </>
  );
}

export default App;
